import axios from "axios";
import Cookies from "js-cookie";
import { REACT_APP_KEY_NAME } from "../utils/constants";
import toast from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import { jsonToQueryParams } from "../helpers/functions";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const getJwt = () => {
  if (Cookies.get(REACT_APP_KEY_NAME) !== undefined && localStorage.getItem(REACT_APP_KEY_NAME)) {
    return Cookies.get(REACT_APP_KEY_NAME);
  } else {
    Cookies.remove(REACT_APP_KEY_NAME);
    localStorage.removeItem(REACT_APP_KEY_NAME);
  }
};

const setJwt = key => {
  Cookies.set(REACT_APP_KEY_NAME, key, {
    expires: 1,
    path: "/",
    secure: false,
  });
  localStorage.setItem(REACT_APP_KEY_NAME, key);
};

const setAuthHeader = token => {
  if (!token) return;
  axios.defaults.headers.common["authorization"] = `Bearer ${token}`;
  setJwt(token);
};

if (getJwt()) {
  setAuthHeader(getJwt());
}

export default class Api {
  //login
  static login = async data => {
    try {
      const res = await axios.post(`/api/v1/auth/login`, data);
      setAuthHeader(res.data?.token);
      toast.success(res?.data?.message);
      return res;
    } catch (error) {
      localStorage.removeItem(REACT_APP_KEY_NAME);
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  //get me profile
  static getMeProfile = async () => {
    try {
      const res = await axios.get(`/api/v1/auth/me`);
      const token = Cookies.get(REACT_APP_KEY_NAME);
      const decode_token = token ? jwtDecode(token) : {};
      if (decode_token.role !== jwtDecode(res.data?.token).role) {
        Cookies.remove(REACT_APP_KEY_NAME);
        localStorage.removeItem(REACT_APP_KEY_NAME);
        window.location.replace("/auth/signin");
      }
      return res;
    } catch (error) {
      Cookies.remove(REACT_APP_KEY_NAME);
      localStorage.removeItem(REACT_APP_KEY_NAME);
      toast.error(error.response.data?.message);
      window.location.replace("/auth/signin");
      return error.response.data;
    }
  };

  //forgot password
  static forgotPassword = async data => {
    try {
      const res = await axios.post(`/api/v1/auth/password/forgot`, data);
      toast.success(res?.data?.message);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  //reset password
  static resetPassword = async data => {
    try {
      const res = await axios.post(`/api/v1/auth/password/reset`, data);
      toast.success(res?.data?.message);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  //change password
  static changePassword = async data => {
    try {
      const res = await axios.put(`/api/v1/auth/password/change`, data);
      toast.success(res?.data?.message);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  //verify account
  static verifyAccount = async token => {
    try {
      const res = await axios.post(`/api/v1/auth/email/verify/${token}`);
      toast.success(res?.data?.message);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  //update my prfoile
  static updateMyProfile = async data => {
    try {
      const res = await axios.put(`/api/v1/user`, data);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  // all quiz
  static allQuiz = async (search, page, limit) => {
    try {
      const res = await axios.get(`/api/v1/quiz/all/?page=${page}&limit=${limit}&search=${search}`);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  // add quiz
  static addQuiz = async data => {
    try {
      const res = await axios.post(`/api/v1/quiz/add`, data);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  // delete quiz
  static deleteQuiz = async id => {
    try {
      const res = await axios.delete(`/api/v1/quiz/${id}`);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  // quiz by id
  static quizById = async id => {
    try {
      const res = await axios.get(`/api/v1/quiz/${id}`);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  // update quiz
  static updateQuiz = async (id, data) => {
    try {
      const res = await axios.put(`/api/v1/quiz/${id}`, data);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };

  // today quiz
  static todayQuiz = async () => {
    try {
      const res = await axios.get(`/api/v1/quiz/today?date=${new Date()}`);
      return res;
    } catch (error) {
      toast.error(error.response.data?.message);
      return error.response.data;
    }
  };
}
